import {
  // Admin constants
  ADMIN_LISTINGS_REQUEST,
  ADMIN_LISTINGS_SUCCESS,
  ADMIN_LISTINGS_FAIL,
  //
  ADMIN_LISTING_DETAILS_REQUEST,
  ADMIN_LISTING_DETAILS_SUCCESS,
  ADMIN_LISTING_DETAILS_FAIL,
  //
  ADMIN_UPDATE_LISTING_REQUEST,
  ADMIN_UPDATE_LISTING_SUCCESS,
  ADMIN_UPDATE_LISTING_FAIL,
  //
  ADMIN_DELETE_LISTING_REQUEST,
  ADMIN_DELETE_LISTING_SUCCESS,
  ADMIN_DELETE_LISTING_FAIL,
  // User constants
  SAVE_PROPERTY_ADDRESS,
  SAVE_PROPERTY_DETAILS,
  NEW_LISTING_REQUEST,
  NEW_LISTING_SUCCESS,
  NEW_LISTING_FAIL,
  //
  USER_LISTINGS_REQUEST,
  USER_LISTINGS_SUCCESS,
  USER_LISTINGS_FAIL,
  //
  USER_LISTING_DETAILS_REQUEST,
  USER_LISTING_DETAILS_SUCCESS,
  USER_LISTING_DETAILS_FAIL,
  // Update
  UPDATE_SAVE_PROPERTY_ADDRESS,
  UPDATE_SAVE_PROPERTY_DETAILS,
  UPDATE_LISTING_REQUEST,
  UPDATE_LISTING_SUCCESS,
  UPDATE_LISTING_FAIL,
  // Delete listing by user
  DELETE_LISTING_USER_REQUEST,
  DELETE_LISTING_USER_SUCCESS,
  DELETE_LISTING_USER_FAIL,
  //
  ALL_LISTINGS_REQUEST,
  ALL_LISTINGS_SUCCESS,
  ALL_LISTINGS_FAIL,
  //
  USER_LIKE_LISTING_SUCCESS,
  USER_UNLIKE_LISTING_SUCCESS,
  //
  USER_UNLIKE_LISTING_SUCCESS_FROM_LIKES,
  // USER_GET_LIKED_LISTINGS_REQUEST,
  USER_GET_LIKED_LISTINGS_SUCCESS,
  USER_GET_LIKED_LISTINGS_FAIL,
  // Public constants ==========================
  GET_LISTINGS_PUBLIC_REQUEST,
  GET_LISTINGS_PUBLIC_SUCCESS,
  GET_LISTINGS_PUBLIC_FAIL,
  //
  CLEAR_ERRORS,
} from "../../constants/listingConstants";
import apiClient from "../../lib/apiClient";

export const savePropertyAddress = (data) => async (dispatch) => {
  dispatch({
    type: SAVE_PROPERTY_ADDRESS,
    payload: data,
  });

  localStorage.setItem("propertyAddress", JSON.stringify(data));
};

export const savePropertyDetails = (data) => async (dispatch) => {
  dispatch({
    type: SAVE_PROPERTY_DETAILS,
    payload: data,
  });

  localStorage.setItem("propertyDetails", JSON.stringify(data));
};

export const createNewListing = (listingData) => async (dispatch) => {
  try {
    dispatch({
      type: NEW_LISTING_REQUEST,
    });

    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };

    const { data } = await apiClient.post(
      "/create/listing/new",
      listingData,
      config
    );

    dispatch({
      type: NEW_LISTING_SUCCESS,
      payload: data,
    });

    localStorage.removeItem("propertyAddress");
    localStorage.removeItem("propertyDetails");
    localStorage.removeItem("propertyImages");
  } catch (error) {
    dispatch({
      type: NEW_LISTING_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

export const getUserListings = (id, currentPage) => async (dispatch) => {
  try {
    dispatch({
      type: USER_LISTINGS_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const link = `/my/listings/${id}?page=${currentPage}`;
    const { data } = await apiClient.get(
      // "/my/listings",
      link,
      config
    );
    dispatch({ type: USER_LISTINGS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: USER_LISTINGS_FAIL,
      // payload: error.response.data.message,
      payload: error && error.response,
    });
  }
};

// Get listing details public and user
export const getListingDetailsPublicAndUser = (id) => async (dispatch) => {
  try {
    dispatch({
      type: USER_LISTING_DETAILS_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.get(
      `/listing/details/${id}`,
      config
    );
    dispatch({ type: USER_LISTING_DETAILS_SUCCESS, payload: data.listing });
  } catch (error) {
    dispatch({
      type: USER_LISTING_DETAILS_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

export const updateSavePropertyAddress = (data) => async (dispatch) => {
  dispatch({
    type: UPDATE_SAVE_PROPERTY_ADDRESS,
    payload: data,
  });

  localStorage.setItem("updatedPropertyAddress", JSON.stringify(data));
};

export const updateSavePropertyDetails = (data) => async (dispatch) => {
  dispatch({
    type: UPDATE_SAVE_PROPERTY_DETAILS,
    payload: data,
  });

  localStorage.setItem("updatedPropertyDetails", JSON.stringify(data));
};

export const updateUserListing = (id, listingData) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_LISTING_REQUEST,
    });

    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };

    const { data } = await apiClient.put(
      `/update/my/listing/${id}`,
      listingData,
      config
    );

    dispatch({
      type: UPDATE_LISTING_SUCCESS,
      payload: data,
    });

    localStorage.removeItem("updatedPropertyAddress");
    localStorage.removeItem("updatedPropertyDetails");
    localStorage.removeItem("updatedPropertyImages");
  } catch (error) {
    dispatch({
      type: UPDATE_LISTING_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// Get listing data to populate fields for updating
export const getMyListingAddressUser = async (id) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.get(
      `/get/my/listing/address/${id}`,
      config
    );
    return data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

export const getMyListingDetailsUser = async (id) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.get(
      `/get/my/listing/details/${id}`,
      config
    );
    return data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

export const getMyListingImagesUser = async (id) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.get(
      `/get/my/listing/images/${id}`,
      config
    );
    return data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};
// Get listing data to populate fields for updating

// Delete listing by user
export const deleteListingUserAction = (id) => async (dispatch) => {
  try {
    dispatch({
      type: DELETE_LISTING_USER_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.delete(
      `/delete/my/listing/${id}`,
      config
    );
    dispatch({ type: DELETE_LISTING_USER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: DELETE_LISTING_USER_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

export const getListings = () => async (dispatch) => {
  try {
    dispatch({
      type: ALL_LISTINGS_REQUEST,
    });
    const { data } = await apiClient.get(
      "/admin/all/users/listings"
    );
    dispatch({ type: ALL_LISTINGS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: ALL_LISTINGS_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};
// like unlike listing //
export const handleLike = (id) => async (dispatch) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.patch(
      "/user/like-listing",
      { id },
      config
    );
    dispatch({ type: USER_LIKE_LISTING_SUCCESS, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const handleUnlike =
  (id, fromLikes, userId, currentPage) => async (dispatch) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };
      const { data } = await apiClient.patch(
        "/user/unlike-listing",
        { id },
        config
      );
      if (fromLikes === true) {
        dispatch({
          type: USER_UNLIKE_LISTING_SUCCESS_FROM_LIKES,
          payload: data,
        });
        dispatch(getUserLikedListings(userId, currentPage));
      } else {
        dispatch({ type: USER_UNLIKE_LISTING_SUCCESS, payload: data });
      }
    } catch (error) {
      console.log(error);
    }
  };
// like unlike listing //
export const getUserLikedListings = (id, currentPage) => async (dispatch) => {
  try {
    // dispatch({
    //   type: USER_GET_LIKED_LISTINGS_REQUEST,
    // });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const link = `/my/liked/listings/${id}?page=${currentPage}`;
    const { data } = await apiClient.get(link, config);
    dispatch({ type: USER_GET_LIKED_LISTINGS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: USER_GET_LIKED_LISTINGS_FAIL,
      // payload: error.response.data.message,
      payload: error && error.response,
    });
  }
};

// ============================== Admin actions ============================== //
export const getListingsAdmin = () => async (dispatch) => {
  try {
    dispatch({
      type: ADMIN_LISTINGS_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.get(
      "/admin/all/users/listings",
      config
    );
    dispatch({ type: ADMIN_LISTINGS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: ADMIN_LISTINGS_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

//
export const getSingleUserListingsAdmin = async (id, currentPage) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.get(
      `/admin/user/listings/${id}?page=${currentPage}`,
      config
    );
    return data;
  } catch (error) {
    return error && error.response && error.response.data.featuredNotFound;
  }
};

// Get listing details admin
export const getListingDetails = (id) => async (dispatch) => {
  try {
    dispatch({
      type: ADMIN_LISTING_DETAILS_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.get(
      `/admin/user/listing/${id}`,
      config
    );
    dispatch({ type: ADMIN_LISTING_DETAILS_SUCCESS, payload: data.listing });
  } catch (error) {
    dispatch({
      type: ADMIN_LISTING_DETAILS_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// Update listing admin
export const updateListingAdmin = (id, listingData) => async (dispatch) => {
  try {
    dispatch({
      type: ADMIN_UPDATE_LISTING_REQUEST,
    });
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.put(
      `/update/user/listing/${id}`,
      config,
      listingData
    );
    dispatch({ type: ADMIN_UPDATE_LISTING_SUCCESS, payload: data.success });
  } catch (error) {
    dispatch({
      type: ADMIN_UPDATE_LISTING_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// Delete listing admin
export const deleteListingAdmin = (id) => async (dispatch) => {
  try {
    dispatch({
      type: ADMIN_DELETE_LISTING_REQUEST,
    });
    const config = {
      withCredentials: true,
    };
    const { data } = await apiClient.delete(
      `/admin/delete/user/listing/${id}`,
      config
    );
    dispatch({ type: ADMIN_DELETE_LISTING_SUCCESS, payload: data.success });
  } catch (error) {
    dispatch({
      type: ADMIN_DELETE_LISTING_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

//////
export const updateUserListingAdmin = (id, listingData) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_LISTING_REQUEST,
    });

    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };

    const { data } = await apiClient.put(
      `/admin/update/user/listing/${id}`,
      listingData,
      config
    );

    dispatch({
      type: UPDATE_LISTING_SUCCESS,
      payload: data,
    });

    localStorage.removeItem("updatedPropertyAddress");
    localStorage.removeItem("updatedPropertyDetails");
    localStorage.removeItem("updatedPropertyImages");
  } catch (error) {
    dispatch({
      type: UPDATE_LISTING_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};

// Get listing data to populate fields for updating
export const getUserListingAddressAdmin = async (id) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.get(
      `/admin/get/user/listing/address/${id}`,
      config
    );
    return data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

export const getUserListingDetailsAdmin = async (id) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.get(
      `/admin/get/user/listing/details/${id}`,
      config
    );
    return data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

export const getUserListingImagesAdmin = async (id) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.get(
      `/admin/get/user/listing/images/${id}`,
      config
    );
    return data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};
//////

// Clear errors
export const clearErrors = () => async (dispatch) => {
  dispatch({
    type: CLEAR_ERRORS,
  });
};

// ============================== Public actions ============================== //

export const getListingsPublicMap =
  (
    query,
    mapSWDebounce,
    mapNEDebounce,
    status,
    currentPage = 1,
    minPriceReq,
    maxPriceReq,
    minBeds,
    minBaths,
    propertySubTypesSend,
    areaUnit,
    sortBy,
    order
  ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_LISTINGS_PUBLIC_REQUEST,
      });

      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };

      let link = `/listings?${
        query ? `keyword=${query}` : ""
      }${
        mapSWDebounce && mapNEDebounce
          ? `&latitude[gte]=${
              mapSWDebounce &&
              Object.values(JSON.parse(JSON.stringify(mapSWDebounce)))[0]
            }&latitude[lte]=${
              mapNEDebounce &&
              Object.values(JSON.parse(JSON.stringify(mapNEDebounce)))[0]
            }&longitude[gte]=${
              mapSWDebounce &&
              Object.values(JSON.parse(JSON.stringify(mapSWDebounce)))[1]
            }&longitude[lte]=${
              mapNEDebounce &&
              Object.values(JSON.parse(JSON.stringify(mapNEDebounce)))[1]
            }`
          : ""
      }&status=${status}&page=${currentPage}${
        maxPriceReq && maxPriceReq !== "" ? `&price[lte]=${maxPriceReq}` : ""
      }${
        minPriceReq && minPriceReq !== "" ? `&price[gte]=${minPriceReq}` : ""
      }${minBeds && minBeds !== "" ? `&beds[gte]=${minBeds}` : ""}${
        minBaths && minBaths !== "" ? `&baths[gte]=${minBaths}` : ""
      }${
        propertySubTypesSend &&
        propertySubTypesSend.length &&
        `&propertySubType=${propertySubTypesSend}`
      }${sortBy && sortBy !== "" && `&sortBy=${sortBy}`}${
        areaUnit ? `&areaUnit=${areaUnit}` : ""
      }${order && order !== "" && `&order=${order}`}`;

      if (status && status === "Rent") {
        link = `/listings?${
          query ? `keyword=${query}` : ""
        }${
          mapSWDebounce && mapNEDebounce
            ? `&latitude[gte]=${
                mapSWDebounce &&
                Object.values(JSON.parse(JSON.stringify(mapSWDebounce)))[0]
              }&latitude[lte]=${
                mapNEDebounce &&
                Object.values(JSON.parse(JSON.stringify(mapNEDebounce)))[0]
              }&longitude[gte]=${
                mapSWDebounce &&
                Object.values(JSON.parse(JSON.stringify(mapSWDebounce)))[1]
              }&longitude[lte]=${
                mapNEDebounce &&
                Object.values(JSON.parse(JSON.stringify(mapNEDebounce)))[1]
              }`
            : ""
        }&status=${status}&page=${currentPage}${
          maxPriceReq && maxPriceReq !== ""
            ? `&rentPrice[lte]=${maxPriceReq}`
            : ""
        }${
          minPriceReq && minPriceReq !== ""
            ? `&rentPrice[gte]=${minPriceReq}`
            : ""
        }${minBeds && minBeds !== "" ? `&beds[gte]=${minBeds}` : ""}${
          minBaths && minBaths !== "" ? `&baths[gte]=${minBaths}` : ""
        }${
          propertySubTypesSend &&
          propertySubTypesSend.length &&
          `&propertySubType=${propertySubTypesSend}`
        }${areaUnit ? `&areaUnit=${areaUnit}` : ""}${
          sortBy && sortBy !== "" && `&sortBy=${sortBy}`
        }${order && order !== "" && `&order=${order}`}`;
      }

      const { data } = await apiClient.get(link, config);
      dispatch({ type: GET_LISTINGS_PUBLIC_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_LISTINGS_PUBLIC_FAIL,
        payload: error && error.response,
      });
    }
  };

export const getFeaturedListings = async (filterBy, sort, order, limit) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.post(
      "/featured/listings",
      {
        filterBy,
        sort,
        order,
        limit,
      },
      config
    );
    return data;
  } catch (error) {
    return (
      error &&
      error.response &&
      error.response.data &&
      error.response.data.featuredNotFound
    );
  }
};
